/**
 * Google Maps 設定
 */
import gmap_style from './gmap_style.js';

window.initMap = () => {
    const mapElems = document.querySelectorAll('.c-map-body');
    for (let elem of mapElems) {
        const dataset = elem.dataset;
        const latlng = {lat: dataset.lat ? Number(dataset.lat) : 0, lng: dataset.lng ? Number(dataset.lng) : 0};
        
        const map = new google.maps.Map(elem, {
            center: latlng,
            zoom: 15,
            styles: gmap_style,
        });
        const image = {
            url: window.devicePixelRatio >= 2 ? '/wp-content/themes/shinsenkai/assets/img/access/marker.png' : '/wp-content/themes/shinsenkai/assets/img/access/marker.png',
            size: new google.maps.Size(60,68),
            /* origin: new google.maps.Point(0,0),
            anchor: new google.maps.Point(0,0), */
            scaledSize: new google.maps.Size(60,68),
        };
        const marker = new google.maps.Marker({
            map: map,
            position: latlng,
            icon: image,
        });
    }
};


// WEBPACK FOOTER //
// ./js/modules/gmap.js